var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9900",
    d: "M57.183,6.594H11.486c-2.762,0-5,2.239-5,5v46.813c0,2.761,2.238,5,5,5h45.696c2.762,0,5-2.239,5-5V11.594 C62.183,8.833,59.944,6.594,57.183,6.594z M51.96,51.417H16.711V36.792H51.96V51.417z M51.96,32.75H16.711V18.125H51.96V32.75z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.211,
    y: 39.292,
    fill: "#FF9900",
    width: 8.499,
    height: 9.625
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.211,
    y: 39.292,
    fill: "#FF9900",
    width: 8.5,
    height: 9.625
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.21,
    y: 39.292,
    fill: "#FF9900",
    width: 8.25,
    height: 9.625
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.21,
    y: 20.625,
    fill: "#FF9900",
    width: 8.25,
    height: 9.625
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.211,
    y: 20.625,
    fill: "#FF9900",
    width: 8.499,
    height: 9.625
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.211,
    y: 20.625,
    fill: "#FF9900",
    width: 8.5,
    height: 9.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmi);
export default __webpack_public_path__ + "static/media/ami.6009c8753c4583b420403139c6678ab7.svg";
export { ForwardRef as ReactComponent };